<template>
  <section class="docs-area">
    <h1>
      {{ $t('docs.header') }}
    </h1>
    <div class="menu-area">
      <div class="first-row">
        <div class="quater">
          <div class="col">
            <div :class="{'item h-100': true, 'active': currentPage === 'intro'}" @click="goToPage('intro')">
              <picture>
                <source srcset="/img/new/notepad.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="622"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:500px"
                  src="/img/new/notepad.png"
                  :alt="$t('docs.intro') + ' Defi Pool Finance'"
                  :title="$t('docs.intro')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.intro') }}
              </div>
              <p class="desc">
                {{ $t('docs.intro_desc') }}
              </p>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
          <div class="col">
            <div :class="{'item': true, 'active': currentPage === 'starter'}" @click="goToPage('starter')">
              <picture>
                <source srcset="/img/new/floaties.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="500"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:500px"
                  src="/img/new/floaties.png"
                  :alt="$t('docs.starter_pack') + ' Defi Pool Finance'"
                  :title="$t('docs.starter_pack')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.starter_pack') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
            <div :class="{'item': true, 'active': currentPage === 'security'}" @click="goToPage('security')">
              <picture>
                <source srcset="/img/new/security.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="500"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:500px"
                  src="/img/new/security.png"
                  :alt="$t('docs.security_audits') + ' Defi Pool Finance'"
                  :title="$t('docs.security_audits')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.security_audits') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
        </div>
        <div class="quater">
          <div class="col">
            <div :class="{'item': true, 'active': currentPage === 'features'}" @click="goToPage('features')">
              <picture>
                <source srcset="/img/new/docs.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="554"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:500px"
                  src="/img/new/docs.png"
                  :alt="$t('docs.features') + ' Defi Pool Finance'"
                  :title="$t('docs.features')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.features') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
            <div :class="{'item': true, 'active': currentPage === 'contracts'}" @click="goToPage('contracts')">
              <picture>
                <source srcset="/img/new/contracts.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="681"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:500px"
                  src="/img/new/contracts.png"
                  :alt="$t('docs.smart_contracts') + ' Defi Pool Finance'"
                  :title="$t('docs.smart_contracts')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.smart_contracts') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
          <div class="col">
            <div :class="{'item h-100': true, 'active': currentPage === 'tokenomics'}" @click="goToPage('tokenomics')">
              <picture>
                <source srcset="/img/new/floatie-token.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="490"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:490px"
                  src="/img/new/floatie-token.png"
                  :alt="$t('docs.tokenomics') + ' Defi Pool Finance'"
                  :title="$t('docs.tokenomics')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.tokenomics') }}
              </div>
              <p class="desc">
                {{ $t('docs.tokenomics_desc') }}
              </p>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="second-row">
        <div class="quater">
          <div class="col">
            <div :class="{'item flex-row': true, 'active': currentPage === 'roadmap'}" @click="goToPage('roadmap')">
              <div class="text-area">
                <div class="h3">
                  {{ $t('docs.roadmap') }}
                </div>
                <p class="desc">
                  {{ $t('docs.roadmap_desc') }}
                </p>
              </div>
              <picture>
                <source srcset="/img/new/roadmap.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="575"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:490px"
                  src="/img/new/roadmap.png"
                  :alt="$t('docs.roadmap') + ' Defi Pool Finance'"
                  :title="$t('docs.roadmap')"
                />
              </picture>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
        </div>
        <div class="quater">
          <div class="col">
            <div :class="{'item': true, 'active': currentPage === 'oracles'}" @click="goToPage('oracles')">
              <picture>
                <source srcset="/img/new/oracle.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="524"
                  sizes="sm:300px md:350px lg:500px xl:450px xxl:500px"
                  src="/img/new/oracle.png"
                  :alt="$t('docs.oracles') + ' Defi Pool Finance'"
                  :title="$t('docs.oracles')"
                />
              </picture>
              <div class="h3">
                {{ $t('docs.oracles') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
          <div class="col">
            <div :class="{'item h-50 disabled': true, 'active': currentPage === 'press_kit'}">
              <div class="h3">
                {{ $t('docs.press_kit') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
            <div :class="{'item h-50 disabled': true, 'active': currentPage === 'links'}">
              <div class="h3">
                {{ $t('docs.links') }}
              </div>
              <div class="chevron-area">
                <ChevronDown />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="contentArea" class="content-area">
      <div ref="intro" :class="{'content': true, 'active': currentPage === 'intro'}">
        <div class="h2">
          {{ $t('docs.intro') }}
        </div>
        <p class="desc">
          {{ $t('docs.intro_long_desc') }}
        </p>
        <div class="icon-row">
          <div class="icon-area">
            <div class="icon">
              <SwapArrows />
            </div>
          </div>
          <div class="text-area">
            <div class="h4">
              {{ $t('docs.swap') }}
            </div>
            <p class="desc">
              {{ $t('docs.swap_desc') }}
            </p>
            <div class="boxes">
              <div class="box">
                <div class="h5">
                  {{ $t('docs.likeable') }}
                </div>
                <p class="desc">
                  {{ $t('docs.likeable_desc') }}
                </p>
                <div class="icon-bg">
                  <Likeable />
                </div>
              </div>
              <div class="box">
                <div class="h5">
                  {{ $t('docs.low_fees') }}
                </div>
                <p class="desc">
                  {{ $t('docs.low_fees_desc') }}
                </p>
                <div class="icon-bg">
                  <LowFee />
                </div>
              </div>
              <div class="box">
                <div class="h5">
                  {{ $t('docs.decentralized') }}
                </div>
                <p class="desc">
                  {{ $t('docs.decentralized_desc') }}
                </p>
                <div class="icon-bg">
                  <Decentralize />
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="icon-row">
          <div class="icon-area">
            <div class="icon">
              <Figures />
            </div>
          </div>
          <div class="text-area">
            <div class="h4">
              {{ $t('docs.liquidity') }}
            </div>
            <p class="desc">
              {{ $t('docs.liquidity_desc') }}
            </p>
            <div class="boxes">
              <div class="box">
                <div class="h5">
                  {{ $t('docs.splashie_pools') }}
                </div>
                <p class="desc">
                  {{ $t('docs.splashie_pools_desc') }}
                </p>
                <div class="icon-bg">
                  <CryptoCoin />
                </div>
              </div>
              <div class="semi-box">
                <div class="box">
                  <div class="h5">
                    {{ $t('docs.farms') }}
                  </div>
                  <p class="desc">
                    {{ $t('docs.farms_desc') }}
                  </p>
                  <div class="icon-bg">
                    <Flamingo />
                  </div>
                </div>
                <div class="box">
                  <div class="h5">
                    {{ $t('docs.fees') }}
                  </div>
                  <p class="desc">
                    {{ $t('docs.fees_desc') }}
                  </p>
                  <div class="icon-bg">
                    <ComputerAnalytics />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="icon-row">
          <div class="icon-area">
            <div class="icon">
              <PoolLadder />
            </div>
          </div>
          <div class="text-area">
            <div class="h4">
              {{ $t('docs.safe') }}
            </div>
            <p class="desc">
              {{ $t('docs.safe_desc') }}
            </p>
          </div>
        </div>
      </div>
      <div ref="starter" :class="{'content': true, 'active': currentPage === 'starter'}">
        <div class="h2">
          {{ $t('docs.starter_pack') }}
        </div>
        <p class="desc">
          {{ $t('docs.starter_pack_long_desc') }}
        </p>
        <p class="desc">
          {{ $t('docs.starter_pack_long_desc2') }}
        </p>
        <div class="wallet-area">
          <picture>
            <source srcset="/img/new/connect_wallet.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="2188"
              sizes="sm:250px md:300px lg:400px xl:500px xxl:600px"
              src="/img/new/connect_wallet.png"
              alt="Connect wallet to earn prize on Defi Pool Finance"
              title="Connect wallet"
              loading="lazy"
            />
          </picture>
          <div class="buttons-area">
            <button type="button" class="btn cyan">
              {{ $t('common.connect_wallet') }}
            </button>
          </div>
        </div>
        <p class="desc">
          {{ $t('docs.starter_pack_long_desc') }}
        </p>
        <div class="h5">
          {{ $t('docs.starter_pack_sure_to') }}
        </div>
        <div class="list-area">
          <div class="list">
            <div class="row">
              <div class="icon-area check">
                <CheckFilled />
              </div>
              <div class="text-area">
                {{ $t('docs.starter_pack_sure_to1') }}
              </div>
            </div>
            <div class="row">
              <div class="icon-area check">
                <CheckFilled />
              </div>
              <div class="text-area">
                {{ $t('docs.starter_pack_sure_to2') }}
              </div>
            </div>
            <div class="row">
              <div class="icon-area check">
                <CheckFilled />
              </div>
              <div class="text-area">
                {{ $t('docs.starter_pack_sure_to3') }}
              </div>
            </div>
          </div>
          <div class="list">
            <div class="row">
              <div class="icon-area cross">
                <CrossFilled />
              </div>
              <div class="text-area">
                {{ $t('docs.starter_pack_sure_to4') }}
              </div>
            </div>
            <div class="row">
              <div class="icon-area cross">
                <CrossFilled />
              </div>
              <div class="text-area">
                {{ $t('docs.starter_pack_sure_to5') }}
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="h2">
          {{ $t('docs.defipool_supports') }}
        </div>
        <div class="wallets-area">
          <a ref="nofollow noreferrer noopener" href="https://metamask.io/" class="wallet" target="_blank">
            <div class="image-area metamask">
              <picture>
                <source srcset="/img/new/metamask.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="275"
                  sizes="sm:175px md:200px lg:225px xl:250px xxl:275px"
                  src="/img/new/metamask.png"
                  alt="Metamask wallet connect on Defi Pool Finance"
                  title="Metamask"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="h5">
              Metamask
            </div>
          </a>
          <a ref="nofollow noreferrer noopener" href="https://www.coinbase.com/" class="wallet" target="_blank">
            <div class="image-area coinbase">
              <picture>
                <source srcset="/img/new/coinbase.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="275"
                  sizes="sm:175px md:200px lg:225px xl:250px xxl:275px"
                  src="/img/new/coinbase.png"
                  alt="Coinbase wallet connect on Defi Pool Finance"
                  title="Coinbase"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="h5">
              Coinbase
            </div>
          </a>
          <a ref="nofollow noreferrer noopener" href="https://walletconnect.com/" class="wallet" target="_blank">
            <div class="image-area walletconnect">
              <picture>
                <source srcset="/img/new/walletconnect.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="275"
                  sizes="sm:175px md:200px lg:225px xl:250px xxl:275px"
                  src="/img/new/walletconnect.png"
                  alt="Wallet Connect on Defi Pool Finance"
                  title="Wallet Connect"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="h5">
              Wallet Connect
            </div>
          </a>
          <a ref="nofollow noreferrer noopener" href="https://fortmatic.com/" class="wallet" target="_blank">
            <div class="image-area formatic">
              <picture>
                <source srcset="/img/new/formatic.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="275"
                  sizes="sm:175px md:200px lg:225px xl:250px xxl:275px"
                  src="/img/new/formatic.png"
                  alt="Fortmatic wallet connect on Defi Pool Finance"
                  title="Fortmatic"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="h5">
              Fortmatic
            </div>
          </a>
          <a ref="nofollow noreferrer noopener" href="https://www.portis.io/" class="wallet" target="_blank">
            <div class="image-area portis">
              <picture>
                <source srcset="/img/new/portis.webp" type="image/webp">
                <nuxt-img
                  fit="inside"
                  width="182"
                  sizes="sm:80px md:100px lg:120px xl:140px xxl:180px"
                  src="/img/new/portis.png"
                  alt="Portis wallet connect on Defi Pool Finance"
                  title="Portis wallet"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="h5">
              Portis wallet
            </div>
          </a>
        </div>
        <hr>
        <div class="section">
          <div class="image-area">
            <picture>
              <source srcset="/img/new/bnbs.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="803"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/bnbs.png"
                alt="Deposit BEP20 on Defi Pool Finance"
                title="BEP20 Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.deposit_bep20') }}
            </div>
            <p class="desc">
              {{ $t('docs.deposit_bep20_desc') }}
            </p>
            <div class="items">
              <div class="item">
                <div class="h6">
                  {{ $t('docs.binance_bridge') }}
                </div>
                <p class="desc">
                  {{ $t('docs.binance_bridge_desc') }}
                </p>
                <a ref="nofollow noreferrer noopener" href="https://docs.binance.org/" class="wallet" target="_blank">
                  docs.binance.org
                </a>
              </div>
              <div class="item">
                <div class="h6">
                  Binance.com
                </div>
                <p class="desc">
                  {{ $t('docs.binance_desc') }}
                </p>
                <a ref="nofollow noreferrer noopener" href="https://binance.com/" class="wallet" target="_blank">
                  binance.com
                </a>
              </div>
              <div class="item">
                <div class="h6">
                  Pointpay.com
                </div>
                <p class="desc">
                  {{ $t('docs.pointpay_desc') }}
                </p>
                <a ref="nofollow noreferrer noopener" href="https://pointpay.io/" class="wallet" target="_blank">
                  upcoming
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="h2">
          {{ $t('docs.connect_wallet') }}
        </div>
        <p class="desc">
          {{ $t('docs.connect_wallet_desc') }}
        </p>
        <div class="h5">
          {{ $t('docs.correct_network') }}
        </div>
        <div class="items">
          <div class="item" :tooltip="$t('common.copy')" @click="copyText($event, 'BNB Smart Chain')">
            <p class="name">
              {{ $t('docs.network_name') }}
            </p>
            <p class="value">
              BNB Smart Chain
            </p>
          </div>
          <div class="item" :tooltip="$t('common.copy')" @click="copyText($event, 'https://bsc-dataseed.binance.org/')">
            <p class="name">
              {{ $t('docs.rpc_url') }}
            </p>
            <p class="value">
              bsc-dataseed.binance.org
            </p>
          </div>
          <div class="item" :tooltip="$t('common.copy')" @click="copyText($event, 'BNB')">
            <p class="name">
              {{ $t('docs.symbol') }}
            </p>
            <p class="value">
              BNB
            </p>
          </div>
          <div class="item" :tooltip="$t('common.copy')" @click="copyText($event, 'https://bscscan.com/')">
            <p class="name">
              {{ $t('docs.explorer_url') }}
            </p>
            <p class="value">
              bscscan.com
            </p>
          </div>
          <div class="item" :tooltip="$t('common.copy')" @click="copyText($event, '56')">
            <p class="name">
              {{ $t('docs.chain_id') }}
            </p>
            <p class="value">
              56
            </p>
          </div>
        </div>
      </div>
      <div ref="oracles" :class="{'content': true, 'active': currentPage === 'oracles'}">
        <section class="section">
          <div class="image-area smaller">
            <picture>
              <source srcset="/img/new/oracle.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="524"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/oracle.png"
                alt="Oracles on Defi Pool Finance"
                title="Oracle Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.oracles') }}
            </div>
            <p class="desc">
              {{ $t('docs.oracles_long_desc') }}
            </p>
          </div>
        </section>
      </div>
      <div ref="contracts" :class="{'content': true, 'active': currentPage === 'contracts'}">
        <section class="section">
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.contracts_links') }}
            </div>
            <p class="desc">
              {{ $t('docs.contracts_links_desc') }}
            </p>
            <ul>
              <li>
                <a ref="nofollow noopener noreferrer" href="https://bscscan.com/address/0xc896d43fe5432fb4660c2a7da420c5d47609cb26" target="_blank">
                  $FLOATIE {{ $t('docs.token') }}
                </a>
              </li>
              <li>
                <a ref="nofollow noopener noreferrer" href="https://bscscan.com/address/0x4caa2ddcf4818e1f3778d9fbb5aaf72136d03966" target="_blank">
                  $SPLASHIE {{ $t('docs.token') }}
                </a>
              </li>
              <li>
                <a ref="nofollow noopener noreferrer" href="https://bscscan.com/address/0xefa0283673b2150a8eeb86d0927ec17511358423" target="_blank">
                  MasterChef
                </a>
              </li>
              <li>
                <a ref="nofollow noopener noreferrer" href="https://bscscan.com/address/0x4aae80fd995f6e983709907ed5d7a413000d5c25" target="_blank">
                  $FLOATIE {{ $t('docs.factory') }}
                </a>
              </li>
              <li>
                <a ref="nofollow noopener noreferrer" href="https://bscscan.com/address/0x79c614ce01ca2cd38b66c43b6c1988a875f6bb29" target="_blank">
                  $FLOATIE {{ $t('docs.router') }}
                </a>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div ref="features" :class="{'content': true, 'active': currentPage === 'features'}">
        <div class="h2">
          {{ $t('docs.swap') }}
        </div>
        <p class="desc">
          {{ $t('docs.swap_long_desc') }}
        </p>
        <div class="items">
          <div class="item no-pointer">
            <div class="h4">
              0.17%
            </div>
            <p class="desc">
              {{ $t('docs.swap_return') }}
            </p>
          </div>
          <div class="item no-pointer">
            <div class="h4">
              0.02%
            </div>
            <p class="desc">
              {{ $t('docs.sent_treasury') }}
            </p>
          </div>
          <div class="item no-pointer">
            <div class="h4">
              0.01%
            </div>
            <p class="desc">
              {{ $t('docs.sent_burn') }}
            </p>
          </div>
        </div>
        <hr>
        <section class="section">
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.liquidity') }}
            </div>
            <p class="desc">
              {{ $t('docs.liquidity_desc1') }}
            </p>
            <p class="desc">
              {{ $t('docs.liquidity_desc2') }}
            </p>
          </div>
          <div class="image-area reverse">
            <picture>
              <source srcset="/img/new/chart_up.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="874"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/chart_up.png"
                alt="Earn and profit on Defi Pool Finance"
                title="Earn with Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
        </section>
        <div class="h5">
          {{ $t('docs.for_example') }}
        </div>
        <div class="items list">
          <div class="item no-pointer">
            <div class="h6">
              {{ $t('docs.example1') }}
            </div>
          </div>
          <div class="item no-pointer">
            <div class="h6">
              1 LP {{ $t('docs.example_token') }} = 1 $FLOATIE + 1 BNB
            </div>
          </div>
          <div class="item no-pointer">
            <div class="h6">
              {{ $t('docs.example3') }}
            </div>
          </div>
          <div class="item no-pointer">
            <div class="h6">
              {{ $t('docs.example4') }}
            </div>
          </div>
          <div class="item no-pointer">
            <div class="h6">
              {{ $t('docs.example5') }}
            </div>
          </div>
          <div class="item no-pointer">
            <div class="h6">
              {{ $t('docs.example6') }}
            </div>
          </div>
        </div>
        <p class="desc">
          {{ $t('docs.example_desc') }}
        </p>
        <section class="section">
          <div class="image-area smaller">
            <picture>
              <source srcset="/img/new/filling_wallet.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="845"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/filling_wallet.png"
                alt="Fill and top up wallet on Defi Pool Finance"
                title="Fill cypto wallet on Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.loss') }}
            </div>
            <p class="desc">
              {{ $t('docs.loss_desc') }}
              <a href="https://academy.binance.com/en/articles/impermanent-loss-explained" target="_blank" rel="nofollow noopener noreferrer">Binance Academy</a>.
            </p>
          </div>
        </section>
        <hr>
        <section class="section">
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.adding_liquidity') }}
            </div>
            <p class="desc">
              {{ $t('docs.adding_liquidity_desc') }}
            </p>
          </div>
          <div class="image-area smaller reverse">
            <picture>
              <source srcset="/img/new/swapping_floatie.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="624"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/swapping_floatie.png"
                alt="Swap BNB and stake on Defi Pool Finance"
                title="Swap BNB and stake on Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
        </section>
        <section class="section boxed">
          <div class="image-area">
            <picture>
              <source srcset="/img/new/placing_chart.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="770"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/placing_chart.png"
                alt="Earn crypto and yeild farm on Defi Pool Finance"
                title="Earn crypto and yeild farme on Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.farming') }}
            </div>
            <p class="desc">
              {{ $t('docs.farming_desc') }}
            </p>
            <div class="h5">
              {{ $t('docs.farming_include') }}
            </div>
            <div class="list-area">
              <div class="list">
                <div class="row">
                  <div class="icon-area check">
                    <CheckFilled />
                  </div>
                  <div class="text-area">
                    {{ $t('docs.farming_include_desc1') }}
                  </div>
                </div>
              </div>
              <div class="list">
                <div class="row">
                  <div class="icon-area check">
                    <CheckFilled />
                  </div>
                  <div class="text-area">
                    {{ $t('docs.farming_include_desc2') }}
                  </div>
                </div>
              </div>
            </div>
            <p class="desc">
              {{ $t('docs.farming_desc2') }}
            </p>
          </div>
        </section>
        <section class="section">
          <div class="text-area">
            <div class="h2">
              {{ $t('docs.stake') }}
            </div>
            <p class="desc">
              {{ $t('docs.stake_long_desc') }}
            </p>
            <ul>
              <li class="normal">
                {{ $t('docs.stake_long_desc_p1') }}
              </li>
              <li class="normal">
                {{ $t('docs.stake_long_desc_p2') }}
              </li>
            </ul>
          </div>
          <div class="image-area smaller reverse">
            <picture>
              <source srcset="/img/new/floaties_coins.webp" type="image/webp">
              <nuxt-img
                fit="inside"
                width="922"
                sizes="sm:300px md:400px lg:500px xl:550px xxl:500px"
                src="/img/new/floaties_coins.png"
                alt="Crypto tokens earning on Defi Pool Finance"
                title="Crypto tokens earning on Defi Pool Finance"
                loading="lazy"
              />
            </picture>
          </div>
        </section>
        <hr>
        <div class="h5">
          {{ $t('docs.looks_like') }}
        </div>
        <div class="cycle">
          <picture v-if="darkTheme">
            <source srcset="/img/new/stake_dark.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="770"
              sizes="sm:500px md:900px lg:1250px xl:1500px xxl:1700px"
              src="/img/new/stake_dark.png"
              alt="Stake and earn crypto on Defi Pool Finance"
              title="Stake and earn crypto farme on Defi Pool Finance"
              loading="lazy"
            />
          </picture>
          <picture v-else>
            <source srcset="/img/new/stake_light.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="770"
              sizes="sm:500px md:900px lg:1250px xl:1500px xxl:1700px"
              src="/img/new/stake_light.png"
              alt="Stake and earn crypto on Defi Pool Finance"
              title="Stake and earn crypto farme on Defi Pool Finance"
              loading="lazy"
            />
          </picture>
        </div>
        <hr>
        <div class="h2">
          {{ $t('docs.long_term_stake') }}
        </div>
        <p class="desc">
          {{ $t('docs.long_term_stake_desc1') }}
        </p>
        <p class="desc">
          {{ $t('docs.long_term_stake_desc2') }}
        </p>
        <p class="desc">
          {{ $t('docs.long_term_stake_desc3') }}
        </p>
        <p class="desc">
          {{ $t('docs.long_term_stake_desc4') }}
        </p>
      </div>
      <div ref="roadmap" :class="{'content': true, 'active': currentPage === 'roadmap'}">
        <div class="h2">
          {{ $t('docs.roadmap') }}
        </div>
        <p class="desc">
          {{ $t('docs.roadmap_long_desc') }}
        </p>
        <div class="roadmap-container">
          <picture v-if="darkTheme">
            <source srcset="/img/new/roadmap_dark.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="770"
              sizes="sm:700px md:1200px lg:1500px xl:1750px xxl:2000px"
              src="/img/new/roadmap_dark.png"
              alt="Roadmap on how Defi Pool Finance is improving and become the most modern DEX service"
              title="Roadmap Defi Pool Finance "
              loading="lazy"
            />
          </picture>
          <picture v-else>
            <source srcset="/img/new/roadmap_light.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="770"
              sizes="sm:500px md:900px lg:1250px xl:1500px xxl:1700px"
              src="/img/new/roadmap_light.png"
              alt="Roadmap on how Defi Pool Finance is improving and become the most modern DEX service"
              title="Roadmap Defi Pool Finance"
              loading="lazy"
            />
          </picture>
        </div>
        <div class="roadmap-flow">
          <div class="flow-section">
            <div class="header">
              <div class="icon">
                <ChevronDown />
              </div>
              <div class="text">
                <div class="h4">
                  {{ $t('docs.ongoing') }}
                </div>
              </div>
            </div>
            <div class="flow-content">
              <div class="subheader">
                2023 Q1
              </div>
              <div class="list">
                <div class="item">
                  <div class="icon">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.governance') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.reward_farms') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.performance') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.site_listings') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.lottery') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.farm_adjustments') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.ido_preparation') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flow-section upcoming">
            <div class="header">
              <div class="icon">
                <ChevronDown />
              </div>
              <div class="text">
                <div class="h4">
                  {{ $t('docs.upcoming') }}
                </div>
              </div>
            </div>
            <div class="flow-content">
              <div class="label">
                + {{ $t('docs.active_pr') }}
              </div>
              <div class="subheader">
                2023 Q2
              </div>
              <div class="list">
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.limit_order') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.zap_liquidity') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.prediction_game') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.lending') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.polygon') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.partnerships') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.ratings') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flow-section exploring">
            <div class="header">
              <div class="icon">
                <ChevronDown />
              </div>
              <div class="text">
                <div class="h4">
                  {{ $t('docs.exploring') }}
                </div>
              </div>
            </div>
            <div class="flow-content">
              <div class="subheader">
                2023 Q2-Q3
              </div>
              <div class="list">
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.cex_listing') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.expert_trading') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.lifebuoy') }}
                  </p>
                </div>
                <div class="item">
                  <div class="icon disabled">
                    <CheckFilled />
                  </div>
                  <p class="desc">
                    {{ $t('docs.assets_pool') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="tokenomics" :class="{'content': true, 'active': currentPage === 'tokenomics'}">
        <div class="h2">
          {{ $t('docs.tokenomics') }}
        </div>
        <div class="h5">
          {{ $t('docs.tokenomics_based') }}
        </div>
        <div class="items list">
          <div class="item">
            <div class="h4">
              1
            </div>
            <div class="h6">
              {{ $t('docs.tokenomics_based_desc1') }}
            </div>
          </div>
          <div class="item">
            <div class="h4">
              2
            </div>
            <div class="h6">
              {{ $t('docs.tokenomics_based_desc2') }}
            </div>
          </div>
          <div class="item">
            <div class="h4">
              3
            </div>
            <div class="h6">
              {{ $t('docs.tokenomics_based_desc3') }}
            </div>
          </div>
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_long_desc') }}
        </p>
        <div class="h5">
          I. FLOATIE - $FLE
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_desc') }}
        </p>
        <div class="h4">
          {{ $t('docs.tokenomics_fle_utility') }}
        </div>
        <ul class="list">
          <li class="item">
            {{ $t('docs.tokenomics_fle_exchange') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_stake') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_payment') }}
          </li>
        </ul>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_created') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_fle_supply') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_supply_desc') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_fle_model') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_model_desc') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_fle_core') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_core_desc') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_fle_schedule') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_schedule_desc') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_fle_burn') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_burn_desc') }}
        </p>
        <div class="h4">
          {{ $t('docs.tokenomics_fle_info') }}
        </div>
        <ul class="list">
          <li class="item">
            {{ $t('docs.tokenomics_fle_name') }}: FLOATIE
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_symbol') }}: $FLE
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_total') }}: 500,000,000
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_hardcap') }}: 3,080,000 USD
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_softcap') }}: 500,000USD
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_chain') }}: Binance Smart Chain (BSC)
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_info_model') }}: {{ $t('docs.tokenomics_fle_info_model_value') }}
          </li>
        </ul>
        <div class="h4">
          {{ $t('docs.tokenomics_fle_allocation') }}
        </div>
        <div class="chart-container">
          <DoughnutChart :chart-data="allocation.data" :options="allocation.options" />
        </div>
        <div class="h6">
          {{ $t('docs.tokenomics_fle_use') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_following') }}:
        </p>
        <ul class="list">
          <li class="item">
            {{ $t('docs.tokenomics_fle_repenish') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_handle') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_community') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_dao') }}
          </li>
        </ul>
        <div class="h5">
          II. {{ $t('docs.tokenomics_phe') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_phe_desc1') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_phe_desc2') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_phe_desc3') }}
        </p>
        <div class="h4">
          {{ $t('docs.tokenomics_phe_utilities') }}
        </div>
        <ul class="list">
          <li class="item">
            {{ $t('docs.tokenomics_phe_rewards') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_phe_assets') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_phe_vote') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_phe_propose') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_phe_staking') }}
          </li>
        </ul>
        <div class="h4">
          {{ $t('docs.tokenomics_fle_staking') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_host') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_allocate') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_program') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_systems') }}
        </p>
        <div class="h6">
          1. {{ $t('docs.tokenomics_fle_flexible') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_flexible_desc') }}
        </p>
        <div class="h6">
          2. {{ $t('docs.tokenomics_fle_fixed') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_fixed_desc1') }}
        </p>
        <p class="desc italic">
          {{ $t('docs.tokenomics_fle_fixed_desc2') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_fle_fixed_based') }}
        </p>
        <ul class="list">
          <li class="item">
            {{ $t('docs.tokenomics_fle_fixed_based_desc1') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_fixed_based_desc2') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_fle_fixed_based_desc3') }}
          </li>
        </ul>
        <div class="tabs">
          <div class="tabs-line">
            <div :class="{'tab': true, 'active': tokenomicsTab === '3m'}" @click="changeTokenomicsTab('3m')">
              3 {{ $t('common.months') }}
            </div>
            <div :class="{'tab': true, 'active': tokenomicsTab === '5m'}" @click="changeTokenomicsTab('5m')">
              5 {{ $t('common.months') }}
            </div>
            <div :class="{'tab': true, 'active': tokenomicsTab === '8m'}" @click="changeTokenomicsTab('8m')">
              8 {{ $t('common.months') }}
            </div>
            <div :class="{'tab': true, 'active': tokenomicsTab === '12m'}" @click="changeTokenomicsTab('12m')">
              12 {{ $t('common.months') }}
            </div>
            <div :class="{'tab': true, 'active': tokenomicsTab === '24m'}" @click="changeTokenomicsTab('24m')">
              24 {{ $t('common.months') }}
            </div>
          </div>
          <div v-if="tokenomicsTab === '3m'" class="content-area">
            <p class="desc">
              {{ $t('docs.tokenomics_higher_apy') }}
            </p>
            <p class="desc">
              {{ $t('docs.tokenomics_receive_airdrop', { float: '1/5' }) }}
            </p>
          </div>
          <div v-if="tokenomicsTab === '5m'" class="content-area">
            <p class="desc">
              {{ $t('docs.tokenomics_higher_apy') }}
            </p>
            <p class="desc">
              {{ $t('docs.tokenomics_receive_airdrop', { float: '2/5' }) }}
            </p>
          </div>
          <div v-if="tokenomicsTab === '8m'" class="content-area">
            <p class="desc">
              {{ $t('docs.tokenomics_higher_apy') }}
            </p>
            <p class="desc">
              {{ $t('docs.tokenomics_receive_airdrop', { float: '3/5' }) }}
            </p>
          </div>
          <div v-if="tokenomicsTab === '12m'" class="content-area">
            <p class="desc">
              {{ $t('docs.tokenomics_higher_apy') }}
            </p>
            <p class="desc">
              {{ $t('docs.tokenomics_receive_airdrop', { float: '4/5' }) }}
            </p>
          </div>
          <div v-if="tokenomicsTab === '24m'" class="content-area">
            <p class="desc">
              {{ $t('docs.tokenomics_higher_apy') }}
            </p>
            <p class="desc">
              {{ $t('docs.tokenomics_receive_full_airdrop') }}
            </p>
          </div>
        </div>
        <div class="h4">
          {{ $t('docs.tokenomics_case_study') }}:
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_translates') }}:
        </p>
        <ul class="list">
          <li class="item">
            40.5 $FLE {{ $t('docs.tokenomics_daily') }}
          </li>
          <li class="item">
            293 $FLE {{ $t('docs.tokenomics_weekly') }}
          </li>
          <li class="item">
            1,220 $FLE {{ $t('docs.tokenomics_monthly') }}
          </li>
          <li class="item">
            14,650 $FLE {{ $t('docs.tokenomics_yearly') }}
          </li>
        </ul>
        <p class="desc">
          {{ $t('docs.tokenomics_rewards_come') }}
        </p>
        <p class="desc italic">
          {{ $t('docs.tokenomics_rewards_come_ps') }}
        </p>
        <div class="h4">
          {{ $t('docs.tokenomics_swap') }}
        </div>
        <p class="desc italic">
          {{ $t('docs.tokenomics_swap_desc') }}
        </p>
        <div class="h4">
          {{ $t('docs.tokenomics_swap_case') }}
        </div>
        <ul class="list">
          <li class="item">
            {{ $t('docs.tokenomics_swap1') }}
            <ul class="list">
              <li class="item">
                {{ $t('docs.tokenomics_swap2') }}
              </li>
              <li class="item">
                {{ $t('docs.tokenomics_swap3') }}
              </li>
            </ul>
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_swap4') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_swap5') }}
          </li>
          <li class="item">
            {{ $t('docs.tokenomics_swap6') }}
          </li>
        </ul>
        <div class="h4">
          {{ $t('docs.tokenomics_swap_schedule') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_swap_schedule_desc1') }}
        </p>
        <p class="desc">
          {{ $t('docs.tokenomics_swap_schedule_desc2') }}
        </p>
        <p class="desc italic">
          {{ $t('docs.tokenomics_swap_schedule_desc3') }}
        </p>
        <div class="h4">
          {{ $t('docs.tokenomics_burning') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_burning_desc') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_burning_buyback') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_burning_buyback_desc') }}
        </p>
        <div class="h6">
          {{ $t('docs.tokenomics_burning_allocation') }}
        </div>
        <ul class="list">
          <li class="item">
            50% - {{ $t('docs.tokenomics_burn_address') }}
          </li>
          <li class="item">
            50% - {{ $t('docs.tokenomics_strength') }}
          </li>
        </ul>
        <div class="h4">
          {{ $t('docs.tokenomics_distribution') }}
        </div>
        <div class="h6">
          {{ $t('docs.tokenomics_dex') }}
        </div>
        <p class="desc">
          1% {{ $t('docs.tokenomics_buy_tax') }}
        </p>
        <ul class="list">
          <li class="item">
            50% {{ $t('docs.tokenomics_buyback') }}
          </li>
          <li class="item">
            30% {{ $t('docs.tokenomics_rewards_pool') }}
          </li>
          <li class="item">
            20% {{ $t('docs.tokenomics_team_wallet') }}
          </li>
        </ul>
        <p class="desc">
          3% {{ $t('docs.tokenomics_sell_tax') }}
        </p>
        <ul class="list">
          <li class="item">
            50% {{ $t('docs.tokenomics_buyback') }}
          </li>
          <li class="item">
            30% {{ $t('docs.tokenomics_rewards_pool') }}
          </li>
          <li class="item">
            20% {{ $t('docs.tokenomics_team_wallet') }}
          </li>
        </ul>
        <div class="h6">
          {{ $t('docs.tokenomics_token_swap') }}
        </div>
        <ul class="list">
          <li class="item">
            0.17% {{ $t('docs.tokenomics_returns') }}
          </li>
          <li class="item">
            0.02% {{ $t('docs.tokenomics_sent_treasury') }}
          </li>
          <li class="item">
            0.01% {{ $t('docs.tokenomics_buyback_burn') }}
          </li>
        </ul>
        <div class="h6">
          {{ $t('docs.tokenomics_straight_swap') }}
        </div>
        <p class="desc">
          {{ $t('docs.tokenomics_outside_schedule') }}
        </p>
        <ul class="list">
          <li class="item">
            50% {{ $t('docs.tokenomics_fle_treasury') }}
          </li>
          <li class="item">
            40% {{ $t('docs.tokenomics_rewards_pool') }}
          </li>
          <li class="item">
            10% {{ $t('docs.tokenomics_burn_address') }}
          </li>
        </ul>
      </div>
    </div>
    <section class="banner">
      <div class="content-area">
        <div class="image-area">
          <picture>
            <source srcset="/img/new/floating_man.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="867"
              sizes="sm:300px md:350px lg:450px xl:500px xxl:550px"
              src="/img/new/floating_man.png"
              alt="Pool rules Defi Pool Finance"
              title="Pool rules"
              loading="lazy"
            />
          </picture>
        </div>
        <div class="text-area">
          <picture v-if="darkTheme">
            <source srcset="/img/new/docs_help.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="867"
              sizes="sm:300px md:350px lg:450px xl:500px xxl:550px"
              src="/img/new/docs_help.png"
              :alt="$t('docs.navigate_header') + ' Defi Pool Finance'"
              :title="$t('docs.navigate_header')"
              loading="lazy"
            />
          </picture>
          <picture v-else>
            <source srcset="/img/new/docs_help_light.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="867"
              sizes="sm:300px md:350px lg:450px xl:500px xxl:550px"
              src="/img/new/docs_help_light.png"
              :alt="$t('docs.navigate_header') + ' Defi Pool Finance'"
              :title="$t('docs.navigate_header')"
              loading="lazy"
            />
          </picture>
          <p class="desc">
            {{ $t('docs.navigate') }}
          </p>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  hydrateWhenIdle,
  hydrateWhenVisible
} from 'vue-lazy-hydration'

export default {
  name: 'DocsPage',
  components: {
    CheckFilled: hydrateWhenVisible(() => import('~/components/svg/new/CheckFilled')),
    ChevronDown: hydrateWhenIdle(() => import('~/components/svg/new/ChevronDown')),
    ComputerAnalytics: hydrateWhenVisible(() => import('~/components/svg/new/ComputerAnalytics')),
    CrossFilled: hydrateWhenVisible(() => import('~/components/svg/new/CrossFilled')),
    CryptoCoin: hydrateWhenVisible(() => import('~/components/svg/new/CryptoCoin')),
    Decentralize: hydrateWhenVisible(() => import('~/components/svg/new/Decentralize')),
    DoughnutChart: hydrateWhenIdle(() => import('~/components/analytics/parts/DoughnutChart')),
    Figures: hydrateWhenVisible(() => import('~/components/svg/new/Figures')),
    Flamingo: hydrateWhenVisible(() => import('~/components/svg/new/Flamingo')),
    Likeable: hydrateWhenVisible(() => import('~/components/svg/new/Likeable')),
    LowFee: hydrateWhenVisible(() => import('~/components/svg/new/LowFee')),
    PoolLadder: hydrateWhenVisible(() => import('~/components/svg/new/PoolLadder')),
    SwapArrows: hydrateWhenVisible(() => import('~/components/svg/new/SwapArrows'))
  },
  layout: 'new',
  data() {
    return {
      currentPage: 'intro',
      tokenomicsTab: '3m',
      allocation: {
        data: {
          labels: [
            this.$t('docs.tokenomics_fle_token_sale'),
            this.$t('docs.tokenomics_fle_marketing'),
            this.$t('docs.tokenomics_fle_rewards'),
            this.$t('docs.tokenomics_fle_game'),
            this.$t('docs.tokenomics_fle_initial'),
            this.$t('docs.tokenomics_fle_team'),
            this.$t('docs.tokenomics_fle_treasury'),
            this.$t('docs.tokenomics_fle_advisors')
          ],
          datasets: [
            {
              data: [15, 10, 39, 15, 1, 10, 5, 5],
              borderWidth: 0,
              backgroundColor: ['#20c8d6', '#2196f3', '#1e88e5', '#6050DC', '#D52DB7', '#FF2E7E', '#FF6B45', '#FFAB05']
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          aspectRatio: 1.5,
          interaction: {
            intersect: false
          },
          plugins: {
            legend: false
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItems, data) => {
                return data.labels[tooltipItems.index] + ': ' + data.datasets[0].data[tooltipItems.index] + '%'
              }
            }
          }
        }
      }
    }
  },
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['darkTheme']),
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    }
  },
  mounted() {
    if (this.$refs[this.currentPage] !== undefined) {
      this.$refs[this.currentPage].style.maxHeight = this.$refs[this.currentPage].scrollHeight + 'px'
    }
    if (window.location.hash) {
      this.goToPage(window.location.hash.substring(1))
    }
  },
  methods: {
    goToPage(newPage) {
      this.nullContentHeight()
      if (this.currentPage.toLowerCase() !== newPage.toLowerCase()) {
        this.currentPage = newPage
        window.location.hash = newPage
      }
      setTimeout(() => {
        if (this.$refs[newPage] !== undefined) {
          this.$refs[newPage].scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      }, 350)
    },
    changeTokenomicsTab(newTab) {
      if (this.tokenomicsTab !== newTab) {
        this.tokenomicsTab = newTab
      }
    },
    copyText(evt, text) {
      this.$copy(evt, text)
      if (evt.target.classList.contains('item')) {
        evt.target.setAttribute('tooltip', this.$t('common.copied'))
        setTimeout(() => {
          evt.target.setAttribute('tooltip', this.$t('common.copy'))
        }, 1000)
      } else {
        const item = evt.target.closest('.item')
        item.setAttribute('tooltip', this.$t('common.copied'))
        setTimeout(() => {
          item.setAttribute('tooltip', this.$t('common.copy'))
        }, 1000)
      }
    },
    nullContentHeight() {
      if (this.$refs.intro !== undefined) {
        this.$refs.intro.style.maxHeight = null
      }
      if (this.$refs.starter !== undefined) {
        this.$refs.starter.style.maxHeight = null
      }
      if (this.$refs.intro !== undefined) {
        this.$refs.intro.style.maxHeight = null
      }
      if (this.$refs.security !== undefined) {
        this.$refs.security.style.maxHeight = null
      }
      if (this.$refs.features !== undefined) {
        this.$refs.features.style.maxHeight = null
      }
      if (this.$refs.contracts !== undefined) {
        this.$refs.contracts.style.maxHeight = null
      }
      if (this.$refs.tokenomics !== undefined) {
        this.$refs.tokenomics.style.maxHeight = null
      }
      if (this.$refs.roadmap !== undefined) {
        this.$refs.roadmap.style.maxHeight = null
      }
      if (this.$refs.oracles !== undefined) {
        this.$refs.oracles.style.maxHeight = null
      }
      if (this.$refs.press_kit !== undefined) {
        this.$refs.press_kit.style.maxHeight = null
      }
      if (this.$refs.links !== undefined) {
        this.$refs.links.style.maxHeight = null
      }
    }
  }
}
</script>

<style scoped>
    @import url('../assets/css/new/docs.css');
</style>
